export { default as PermissionsContent } from './PermissionsContent';
